import { render } from "./ReleaseVerSection.vue?vue&type=template&id=e07c7b84"
import script from "./ReleaseVerSection.vue?vue&type=script&lang=js"
export * from "./ReleaseVerSection.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src1932422480/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__